module.exports = {"532329101":"狮山镇","532329102":"高桥镇","532329103":"猫街镇","532329104":"插甸镇","532329105":"白路镇","532329106":"万德镇","532329107":"己衣镇","532329202":"田心乡","532329203":"发窝乡","532329207":"环州乡","532329208":"东坡傣族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532329.json
// module id = 2622
// module chunks = 0